<template>
<div class="container">
        <h2>Thank You for contact SPOT GURUS!</h2>
        <div class="support-details">
            <h3>Support Details</h3>
            <p>If you need assistance, please contact our support team:</p>
            <ul>
                <li>Email: spotgurus@gmail.com</li>
                <li>Phone: +1 (212) 202-0236</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 0;
        background-color: #f4f4f4;
    }

    .container {
        max-width: 1200px;
        margin: 20px auto;
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }

    h2 {
        text-align: center;
        color: #333;
    }

    .support-details {
        margin-top: 30px;
        padding: 20px;
        background-color: #f9f9f9;
        border-radius: 5px;
    }

    .support-details h3 {
        color: #333;
        margin-bottom: 10px;
    }

    .support-details p {
        color: #666;
    }
</style>
